<template>
    <button
        type="button"
        class="c-choice"
        :style="rootStyle"
        @click="onClick"
    >
        <span class="c-choice__icon" :style="iconStyle">{{ icon }}</span>
        <div>
            <div class="c-choice__label" :style="labelStyle">{{ label }}</div>
            <div class="c-choice__sub" :style="subStyle">{{ sub }}</div>
        </div>
    </button>
</template>

<script>
import {
    C_INK,
    C_INK2,
    C_HAIR,
    C_BG,
    C_CREAM,
    C_GREEN,
    FONT_DISPLAY,
    FONT_BODY,
} from './tokens';

export default {
    name: 'CChoice',
    props: {
        selected: { type: Boolean, default: false },
        icon: { type: String, default: '' },
        label: { type: String, default: '' },
        sub: { type: String, default: '' },
        // Visual tone — 'green' for affirmative answers, 'neutral' otherwise.
        tone: {
            type: String,
            default: 'neutral',
            validator: (v) => ['neutral', 'green'].includes(v),
        },
    },
    computed: {
        accent() {
            return this.tone === 'green' ? C_GREEN : C_INK;
        },
        rootStyle() {
            return {
                textAlign: 'left',
                padding: '20px 22px',
                background: this.selected
                    ? this.tone === 'green'
                        ? '#EAF6EF'
                        : C_CREAM
                    : '#fff',
                border: `2px solid ${this.selected ? this.accent : C_HAIR}`,
                borderRadius: '16px',
                cursor: 'pointer',
                fontFamily: FONT_BODY,
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
                transition: 'all 120ms',
            };
        },
        iconStyle() {
            return {
                width: '44px',
                height: '44px',
                borderRadius: '14px',
                flexShrink: 0,
                background: this.selected ? this.accent : C_BG,
                color: this.selected ? '#fff' : C_INK2,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '20px',
                fontWeight: 700,
            };
        },
        labelStyle() {
            return {
                fontFamily: FONT_DISPLAY,
                fontSize: '17px',
                fontWeight: 700,
                letterSpacing: '-0.2px',
                color: C_INK,
            };
        },
        subStyle() {
            return {
                fontSize: '12px',
                color: '#7A6E5F',
                marginTop: '2px',
            };
        },
    },
    methods: {
        onClick(event) {
            this.$emit('click', event);
        },
    },
};
</script>
